/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

	// ver1.0.1

	// ヒーローヘッダー　100vhのスマホ対応
	function setHeight() {
	  let vh = window.innerHeight * 0.01;
	}
	setHeight();

	var menuState = false;
	var dropState = false;

	window.addEventListener("load", function () {
		// 251113 パフォーマンス改善：スライダー実行位置移動前（確認後不要であれば削除でOK）
	  // $(".mainSlider").each(function () {
	  //   const $this = $(this);
	  //   const data = $this.data();

	  //   const defaultOptions = {
	  //     dots: data["dot"] !== false,
	  //     arrow: data["arrow"] !== false,
	  //     infinite: true,
	  //     autoplay: true,
	  //     autoplaySpeed: 5000,
	  //     lazyLoad: "progressive",
	  //     slidesToShow: 3,
	  //     slidesToScroll: 1,
	  //     responsive: [
	  //       {
	  //         breakpoint: 1620,
	  //         settings: {
	  //           slidesToShow: 1,
	  //           slidesToScroll: 1,
	  //         },
	  //       }
	  //     ],
	  //   };

	  //   const slideCount = $this.children("li").length;
	  //   const randomStart = Math.floor(Math.random() * slideCount);

	  //   if (data["center"] === true) {
	  //     $.extend(defaultOptions, {
	  //       centerMode: true,
	  //       centerPadding: "30px",
	  //       variableWidth: true
	  //     });
	  //   } else if (data["fade"] === true) {
	  //     $.extend(defaultOptions, {
	  //       fade: true,
	  //       pauseOnFocus: false,
	  //       pauseOnHover: false
	  //     });
	  //     $this.on({
	  //       beforeChange: function (event, slick, currentSlide, nextSlide) {
	  //         $(".slick-slide", this).eq(currentSlide).addClass("preve-slide");
	  //         $(".slick-slide", this).eq(nextSlide).addClass("fadeAnimetion");
	  //       },
	  //       afterChange: function () {
	  //         $(".preve-slide", this).removeClass("preve-slide fadeAnimetion");
	  //       }
	  //     });
	  //     $this.find(".slick-slide").eq(0).addClass("fadeAnimetion");
	  //   } else {
	  //     $.extend(defaultOptions, {
	  //       initialSlide: randomStart
	  //     });
	  //   }

	  //   $this.slick(defaultOptions);
	  // });

	  // const $contentSliders = $(".contentsSlider");
		// function setContentSlider() {
		// 	const windowWidth = $(window).width();
		// 	if ($contentSliders.length) {
		// 		$contentSliders.each(function () {
		// 			const $this = $(this);
		// 			const pcshow = $this.data("pcshow") || 4;
		// 			const pcscroll = $this.data("pcscroll") || 4;
		// 			const spshow = $this.data("spshow") || 2;
		// 			const spscroll = $this.data("spscroll") || 2;
		// 			const infinite = !($this.data("infinite") == false || $this.hasClass("itemList--ranking"));

		// 			const responsiveOptions = $this.data("spUnslick") ? [
		// 				{
		// 					breakpoint: 991,
		// 					settings: "unslick"
		// 				},
		// 			] : [
		// 				{
		// 					breakpoint: 991,
		// 					settings: {
		// 						slidesToShow: 3,
		// 						slidesToScroll: 3,
		// 					},
		// 				},
		// 				{
		// 					breakpoint: 768,
		// 					settings: {
		// 						slidesToShow: spshow,
		// 						slidesToScroll: spscroll,
		// 					},
		// 				},
		// 			];

		// 			const defaultOptions = {
		// 				dots: false,
		// 				arrow: true,//20251009 尾 左右矢印消し
		// 				infinite: infinite,
		// 				lazyLoad: "progressive",
		// 				slidesToShow: pcshow,
		// 				slidesToScroll: pcscroll,
		// 				autoplay: false,//20251009 尾 自動再生なし
		// 				autoplaySpeed: 5000,
		// 				speed: 450,
		// 				swipe: true,
		// 				responsive: [...responsiveOptions],
		// 			};

		// 			//251031下記コンソールエラー回避アクティブではないスライダーにフォーカスが当たっていた場合は解除(blur)
		// 			$this.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
		// 				var $focusedElement = $(document.activeElement);
		// 				if ($focusedElement.length && $this.is($focusedElement.closest('.contentsSlider'))) {
		// 					$focusedElement.blur();
		// 				}
		// 			});

		// 			const breakpoint = 991;
		// 			if (windowWidth >= breakpoint) {
		// 				if (!$this.hasClass('slick-initialized')) {
		// 					$this.slick(defaultOptions);
		// 				}
		// 			} else {
		// 				if( ($this.data("spUnslick") == true)){
		// 					if ($this.hasClass('slick-initialized')) {
		// 						$this.slick('unslick');
		// 					}
		// 				}else {
		// 					if (!$this.hasClass('slick-initialized')) {
		// 						$this.slick(defaultOptions);
		// 					}
		// 				}
		// 			}
		// 		});
		// 	}
		// }
		// setContentSlider();

		// let resizeTimer;
		// $(window).on('resize', function() {
		// 	clearTimeout(resizeTimer);

		// 	resizeTimer = setTimeout(function() {
		// 		setContentSlider();
		// 	}, 300);
		// });
		// ./251113 パフォーマンス改善：スライダー実行位置移動前（確認後不要であれば削除でOK）

	  if ($(".mainVisual--integrate").length && $(".hdr--integrate").length) {
	    var hdr = $(".hdr--integrate");
	    hdr.addClass("active");
	    $(window).on("scroll", function (event) {
	      var scroll = $(window).scrollTop();
	      if (scroll > 300) {
	        hdr.addClass("integrate--fixed");
	      } else {
	        hdr.removeClass("integrate--fixed");
	      }
	    });
	  } else if ($(".hdr--integrate").length) {
	    hdrFixed($(".hdr--integrate"));
	  }

	  // 初期化
	  sNavOut(".header__nav");

	  // ナビ固定
	  // 共通
		// 20251007ヘッダー追従+展開アニメーションのため、hdr--crkr-fixedクラスがある場合はデフォルトの処理を回避
		if($('#hdr').length && !$('#hdr').hasClass('hdr--crkr-fixed') && !$('#hdr').hasClass('hdr--crkr-renewal')){
			if ($(".hdrFixed").length) {
				hdrFixed($(".hdrFixed"));
			} else {
				var ua = navigator.userAgent;
				// タブレット・スマートフォン時
				if (
					((ua.indexOf("iPhone") > 0 || ua.indexOf("Android") > 0) &&
						ua.indexOf("Mobile") > 0) ||
					ua.indexOf("iPad") > 0
				) {
					if ($(".hdrFixed--sp").length) {
						hdrFixed($(".hdrFixed--sp"));
					}
					// PC
				} else {
					if ($(".hdrFixed--pc").length) {
						hdrFixed($(".hdrFixed--pc"));
					}
				}
			}
		}

	  function hdrFixed(target) {
	    target.after('<div class="h_box"></div>');
	    var h = target.height();
	    var h_top = target.offset().top;
	    $(".h_box").height("0");
	    $(window).on("load scroll resize", function (event) {
	      var scroll = $(window).scrollTop();
	      if (scroll >= h_top) {
	        target.css({
	          position: "fixed",
	          top: "0px",
	          width: "100%",
	          "z-index": "998",
	        });
	        $(".h_box").height(h);
	      } else {
	        target.css({
	          position: "",
	        });
	        $(".h_box").height("0");
	      }
	    });
	  }
	});

	// ハンバーガーメニュー展開
	function closeDrawerMenu() {
		$("#drawer").removeClass("open");
	  $("#menu-icon").removeClass("open");
	  $("#overlay").removeClass("open");
	  $("body").removeClass("open");
		$('#headerDrawerOverlay').fadeOut(300);
	}

	$(document).on("click", ".menuToggle", function () {
	  $("#drawer").toggleClass("open");
	  $("#menu-icon").toggleClass("open");
	  $("#overlay").toggleClass("open");
	  $("body").toggleClass("open");
		$('#headerDrawerOverlay').fadeToggle(300);
	  return false;
	});

	$(document).on("click", ".menuClose", function () {
	  closeDrawerMenu();
	  return false;
	});

	$(document).on("click", "#headerDrawerOverlay", function () {
	  closeDrawerMenu();
	  return false;
	})

	// 20251105 ドロワーメニュー内ページ内アンカーリンクボタンを押した時の挙動
	// ボタンクリックでドロワーを閉じる
	$(function() {
		const pathname = window.location.pathname;
		if (pathname === '/') {
			$(document).on("click", ".handle-drawer-display", function (e) {
				e.preventDefault();
				const href = $(this).attr('href');
				closeDrawerMenu();
				location.hash = href;
				return false;
			})
		}
	})

	// SPのみアコーディオン
	$(document).on("click", ".sp-toggle", function () {
	  var windowWidth = $(window).width();
	  if (windowWidth < 768) {
	    $(this).next("ul").slideToggle();
	    $(this).toggleClass("open");
	  }
	});

	$(document).on("click", ".hdrSearch--toggle > span,.hdrSearch--toggle > a", function () {
	  const $this = $(this);
	  const $icon = $this.find(".material-icons");
	  const iconText = $icon.text();

	  $this.next().slideToggle();
	  if (iconText === "search") {
	    $icon.text("close");
	  } else if (iconText === "close") {
	    $icon.text("search");
	  }

	  return false;
	});


	// ナビゲーション　子要素展開
	$(function () {
	  var ua = navigator.userAgent;
	  // タブレット・スマートフォン時
	  if (
	    ((ua.indexOf("iPhone") > 0 || ua.indexOf("Android") > 0) &&
	      ua.indexOf("Mobile") > 0) ||
	    ua.indexOf("iPad") > 0
	  ) {
	    $(".hasChildren > a")
	      .on("mouseenter touchstart", function () {
	        $(this).toggleClass("open");
	        $(this).next("ul,.megaMenu").toggleClass("open");
	        return false;
	      })
	      .on("mouseleave touchend", function () {
	        return false;
	      });
	    $(".hasChildren .hasChildren--close > a").on(
	      "mouseenter touchstart",
	      function () {
	        $(this).parents("ul").removeClass("open").prev("a").removeClass("open");
	        return false;
	      }
	    );
	  } else {
	    // PC時
	    $(".hasChildren")
	      .on("mouseenter focusin", function () {
	        $(this).children("a").addClass("open");
	        $(this).children("ul,.megaMenu").addClass("open");
	      })
	      .on("mouseleave focusout", function () {
	        $(this).children("a").removeClass("open");
	        $(this).children("ul,.megaMenu").removeClass("open");
	      });
	  }
	});

	$(document).on('click', '.hasChildren--click > a,.hasChildren--click > span,.hasChildren--click > h3', function() {
	  const $this = $(this);
	  const $ul = $this.next('ul');

	  if ($this.hasClass('open')) {
	    $this.removeClass('open');
	    $ul.removeClass('open').slideUp();
	  } else {
	    const $gNav = $this.closest('.gNav');
	    $gNav.find('.hasChilds > span').removeClass('open');
	    $gNav.find('.hasChilds > span').next('ul').removeClass('open').slideUp(0);
	    $this.addClass('open');
	    $ul.addClass('open').slideDown();
	  }

	  return false;
	});


	$(document).on("click", ".hasChildren--clickSP > h2", function () {
	  var windowWidth = $(window).width();
	  if (windowWidth < 768) {
	    var next = $(this).next();
	    if ($(this).hasClass("open")) {
	      $(this).removeClass("open");
	      next.removeClass("open");
	      next.slideUp();
	    } else {
	      const all = $(this)
	        .parents("li")
	        .parents()
	        .parents(".gNav")
	        .find(".hasChilds > span");
	      all.removeClass("open");
	      all.next().removeClass("open").slideUp(0);
	      $(this).addClass("open");
	      next.addClass("open").slideDown();
	    }
	    return false;
	  }
	});

	// SPヘッダーD　カテゴリーナビ
	$(document).on("click", ".hdrCatMenu--toggle", function () {
	  if ($(this).hasClass("open")) {
	    $(this).removeClass("open");
	    $(this).next("ul").removeClass("open").slideUp();
	  } else {
	    $(".hdrCatMenu--toggle.open").next("ul").hide().removeClass("open");
	    $(".hdrCatMenu--toggle.open").removeClass("open");
	    $(this).addClass("open");
	    $(this).next("ul").addClass("open").slideDown();
	  }
	  return false;
	});

	function sNavIn(_this) {
	  $(_this).addClass("open");
	  $(".menuBg--close").addClass("open");
	  $(_this).css({
	    left: 0,
	  });
	}

	function sNavOut(_this) {
	  var windowWidthMinus = document.documentElement.clientWidth * -1;
	  $(_this).removeClass("open");
	  $(".menuBg--close").removeClass("open");
	  $(_this).css({
	    left: windowWidthMinus,
	  });
	}

	// スクロールボタン
	$(function () {
	  if ($(".mainSliderSec").length || $(".mainVisual").length) {
			let position = $(window).height();
	    if ($(".mainVisual--hero").length) {
	      position = $(window).height();
	    } else if ($(".mainSliderSec").length) {
				const $nextEl = $(".mainSliderSec").next(); 
				if ($nextEl.length) {
					position = $nextEl.offset().top;
				}
	    } else {
				const $nextEl = $(".mainVisual").next();
				if ($nextEl.length) {
					position = $nextEl.offset().top;
				}
	    }
			if($("#scrollBtn")){
				$("#scrollBtn").click(function () {
					$("html,body").animate(
						{
							scrollTop: position, // さっき変数に入れた位置まで
						},
						{
							queue: false, // どれくらい経過してから、アニメーションを始めるか。キュー[待ち行列]。falseを指定すると、キューに追加されずに即座にアニメーションを実行。
						}
					);
					return false;
				});
			}
	  }
	});

	// TOPに戻るボタン
	$(function() {
	  const $toTop = $("#toTop");

	  if ($toTop.length) {
	    $toTop.hide();

	    $(window).on('scroll', function() {
	      if ($(this).scrollTop() > 800) {
	        $toTop.fadeIn();
	      } else {
	        $toTop.fadeOut();
	      }
	    });

	    $toTop.on('click', function() {
	      $("body,html").animate({scrollTop: 0}, 500);
	      return false;
	    });
	  }
	});

	// 検索ランキングキーワード
	$(function () {
	  // テキストボックスにフォーカス時、フォームの背景色を変化
	  $('.keywordRanking input[type="text"]')
	    .focusin(function (e) {
	      $(this)
	        .parents(".keywordRanking")
	        .next(".keywordRanking__toggle")
	        .addClass("open");
	    })
	    .focusout(function (e) {
	      setTimeout(function () {
	        $(".keywordRanking__toggle.open").removeClass("open");
	      }, 200);
	    });
	});

	// マルチグリッド横スクロール
	$(function () {
	  $(".lightSlider .multiGrid").each(function () {
	    const $grid = $(this);
	    const $slider = $grid.parents(".lightSlider");

	    $grid.after('<div class="prevBtn"></div>', '<div class="nextBtn"></div>');
	  
	    const $leftButton = $grid.next(".prevBtn");
	    const $rightButton = $leftButton.next(".nextBtn");
	  
	    let width = 0;
	    $grid.children("li").each(function () {
	      width += $(this).outerWidth(true);
	    });
	  
	    //右へ
	    $rightButton.click(function () {
	      $grid.animate({ scrollLeft: $grid.scrollLeft() + 600 }, 300);
	      return false;
	    });

	    //左へスクロールで表示
	    $grid.scroll(function () {
	      if ($grid.scrollLeft() < width - $grid.width()) {
	        $rightButton.fadeIn();
	      } else {
	        $rightButton.fadeOut();
	      }
	    });

	    //左へ
	    $leftButton.click(function () {
	      $grid.animate({ scrollLeft: $grid.scrollLeft() - 600 }, 300);
	      return false;
	    });

	    //右へスクロールで表示
	    $leftButton.hide();
	    $grid.scroll(function () {
	      if ($grid.scrollLeft() > 0) {
	        $leftButton.fadeIn();
	      } else {
	        $leftButton.fadeOut();
	      }
	    });
	  });
	});

	// テキスト横スクロール
	var spSwiperDone = false;
	$(window).on("load resize", function (event) {
	  if (
	    window.innerWidth < 992 &&
	    spSwiperDone == false &&
	    $(".spSwiper").length
	  ) {
	    $(".spSwiper").slick({
	      autoplay: false,
	      speed: 300,
	      slidesToShow: 0,
	      slidesToScroll: 1,
	      centerMode: false,
	      variableWidth: true,
	      touchMove: true,
	      swipeToSlide: true,
	      infinite: false,
	    });

	    spSwiperDone = true;
	  }
	});

	// タブ切り替え
	$(function() {
	  $(".tabSwitch > li").on('click', function() {
	    var $this = $(this);
	    if (!$this.hasClass('active')) {
	      $this.siblings().removeClass('active');
	      $this.addClass('active');

	      var tabNum = $this.index();
	      var $tabContents = $this.closest(".tab").find(".tabContent");
	      
	      $tabContents.hide().eq(tabNum).fadeIn("500");
				$tabContents.removeClass('active');
				$tabContents.eq(tabNum).addClass('active');
				//タブ内にスライダーがある場合、タブを切り替えるとスライダーが1枚目から再スタートする
				const $activeSlider = $tabContents.eq(tabNum).find(".contentsSlider") && $tabContents.eq(tabNum).find(".contentsSlider");
				if($activeSlider){
					$activeSlider.slick('slickGoTo', 0);
				}
        $(".contentsSlider").slick('setPosition');
	    }
	  });
	});

	$(function() {
	  if ($(".wow").length) { 
	    $(window).on("scroll", function () {
	      $(".wow").each(function () {
	        var position = $(this).offset().top;
	        var scroll = $(window).scrollTop();
	        var windowHeight = $(window).height();
	        if (scroll > position - windowHeight + windowHeight / 4) {
	          $(this).addClass("animated");
	        }
	      });
	    });
	  }
	});

	if (window.innerWidth < 767) {
	  $(".cateList__hasChildren").click(function () {
	    $(this).toggleClass("open").next().toggleClass("open").slideToggle();
	    return false;
	  });
	}

	// 詳細検索モーダル
	$(document).on("click", "#mdsBg,#mdsClose", function () {
	  $("#modalDetailSearch").removeClass("open");
	  return false;
	});

	$(document).on("click", "#openDetailSearch", function () {
	  $("#modalDetailSearch").addClass("open");
	  return false;
	});

	$(function(){
	  $('.pickSlider_go').slick({
	    autoplay: true, // 自動でスクロール
	    autoplaySpeed: 0, // 自動再生のスライド切り替えまでの時間を設定
	    speed: 10000, // スライドが流れる速度を設定
	    cssEase: "linear", // スライドの流れ方を等速に設定
	    slidesToShow: 3, // 表示するスライドの数
	    swipe: false, // 操作による切り替えはさせない
	    arrows: false, // 矢印非表示
	    pauseOnFocus: false, // スライダーをフォーカスした時にスライドを停止させるか
	    pauseOnHover: false, // スライダーにマウスホバーした時にスライドを停止させるか
	  });
	  $(".pickSlider_back").slick({
	    autoplay: true, // 自動でスクロール
	    autoplaySpeed: 0, // 自動再生のスライド切り替えまでの時間を設定
	    speed: 10000, // スライドが流れる速度を設定
	    cssEase: "linear", // スライドの流れ方を等速に設定
	    slidesToShow: 3, // 表示するスライドの数
	    swipe: false, // 操作による切り替えはさせない
	    arrows: false, // 矢印非表示
	    pauseOnFocus: false, // スライダーをフォーカスした時にスライドを停止させるか
	    pauseOnHover: false, // スライダーにマウスホバーした時にスライドを停止させるか
	    rtl: true, // スライダーを左から右に流す（逆向き）
	  });
	});

    // FAQ
    $(document).on('click', '.faqWrap:not(.faqWrap--noJS) dt', function() {
    $(this).toggleClass('open').next('dd').slideToggle(0);
    });



/***/ })
/******/ ]);

/* 20251007 header追従+展スクロール時開アニメーション */
window.addEventListener('load', () => {
	function handleFixedHeader() {
		const $fixedHeader = $('#hdr.hdr--crkr-fixed');

		if (!$fixedHeader || $fixedHeader.length === 0) {
			return;
		}

		const $headerBottomPC = $('.hdrFixed--pc .hdrBottom.pcOnly');
		const $headerTop = $('#hdr.hdr--crkr-fixed .hdrTop');
		const $headerBottomSP = $('.hdrFixed--pc .hdrBottom.hdrBottom_search.spOnly');
		const $announcementBar = $('#announcementBarGroup');

		let isHeaderVisible = true;
		const SCROLL_THRESHOLD = 100;
		let lastScrollPosition = 0;

		const handleScrollHeader = () => {
			const currentScrollPosition = $(window).scrollTop();

			if (currentScrollPosition < SCROLL_THRESHOLD) {
				if (!isHeaderVisible) {
					$headerBottomPC.removeClass('is-hidden');
					$announcementBar.slideDown(300);
					isHeaderVisible = true;
				}
				return;
			}
		
			if (currentScrollPosition > lastScrollPosition) {
				if (isHeaderVisible) {
					$headerBottomPC.addClass('is-hidden');
					$announcementBar.slideUp(300);
					isHeaderVisible = false;
				}
			} 
			else {
				if (!isHeaderVisible) {
					$headerBottomPC.removeClass('is-hidden');
					$announcementBar.slideDown(300);
					isHeaderVisible = true;
				}
			}
			lastScrollPosition = currentScrollPosition <= 0 ? 0 : currentScrollPosition;
		}

		const handleScrollHeaderSP = () => {
			const currentScrollPosition = $(window).scrollTop();
			if(currentScrollPosition > 100){
				$headerTop.addClass('is-hidden');
				$headerBottomSP.addClass('is-hidden');
				$announcementBar.slideUp(300);
			}else {
				$headerTop.removeClass('is-hidden');
				$headerBottomSP.removeClass('is-hidden');
				$announcementBar.slideDown(300);
			}
		}

		const debounce = (func, delay) => {
			let timeout;
			return (...args) => {
				clearTimeout(timeout);
				timeout = setTimeout(() => {
					func.apply(this, args);
				}, delay);
			};
		};

		$(window).on('scroll', () => {
			if(window.innerWidth > 991){
				handleScrollHeader();
			}else {
				//handleScrollHeaderSP();
			}
		});
	}
	handleFixedHeader();

	function handleStickyHeader() {

		const $headerBlock = $('#stickyHeaderBlock');
		let headerBlockOffsetTop = $headerBlock.offset().top;

		const $headerBottomPC = $('.hdrFixed--pc .hdrBottom.pcOnly');
		
		let isHeaderVisible = true;
		const SCROLL_THRESHOLD = 70;
		let lastScrollPosition = 0;

		const setHeaderPCFixed = () => {
			const scrollY = $(window).scrollTop();
			if (scrollY > headerBlockOffsetTop) {
				$headerBlock.addClass('is-fixed');
			} else {
				$headerBlock.removeClass('is-fixed');
			}
		}

		let isToggling = false;
		const TOGGLE_DURATION = 300;
		const SCROLL_DELTA = 10;

		const lockScrollDetection = () => {
			isToggling = true;
			setTimeout(() => {
				isToggling = false;
				lastScrollPosition = $(window).scrollTop();
			}, TOGGLE_DURATION);
		};

		const handleScrollHeader = () => {
			if (isToggling) return;

			const currentScrollPosition = $(window).scrollTop();

			if (currentScrollPosition < 0) return;

			if (currentScrollPosition < SCROLL_THRESHOLD) {
				if (!isHeaderVisible) {
					$headerBottomPC.removeClass('is-hidden');
					isHeaderVisible = true;
				}
				lastScrollPosition = currentScrollPosition;
				return;
			}

			if (Math.abs(lastScrollPosition - currentScrollPosition) <= SCROLL_DELTA) {
        return;
      }
		
			if (currentScrollPosition > lastScrollPosition) {
				if (isHeaderVisible) {
					$headerBottomPC.addClass('is-hidden');
					isHeaderVisible = false;
					lockScrollDetection();
				}
			} 
			else {
				if (!isHeaderVisible) {
					$headerBottomPC.removeClass('is-hidden');
					isHeaderVisible = true;
					lockScrollDetection();
				}
			}
			lastScrollPosition = currentScrollPosition <= 0 ? 0 : currentScrollPosition;
		}

		$(window).on('scroll', () => {
			if(window.innerWidth > 991){
				//setHeaderPCFixed();
				handleScrollHeader();
			}
		});
	}
	handleStickyHeader()

})
/* ./20251007 header追従+展スクロール時開アニメーション */

// カート追加ボタン
/*document.addEventListener('DOMContentLoaded', () => {
  const cartBtn = document.getElementById('ProductSubmitButton-');
  let isVisible = false;

  window.addEventListener('scroll', () => {
    const scrollY = window.scrollY || window.pageYOffset;

    if (scrollY > 800 && !isVisible) {
      cartBtn.classList.add('active');
      isVisible = true;
    } else if (scrollY <= 800 && isVisible) {
      cartBtn.classList.remove('active');
      isVisible = false;
    }
  });
});*/

// 251113 パフォーマンス改善：スライダー実行位置移動後
// $(function() {
  $(".mainSlider").each(function () {
		const $this = $(this);
		const data = $this.data();

		const defaultOptions = {
			dots: data["dot"] !== false,
			arrow: data["arrow"] !== false,
			infinite: true,
			autoplay: true,
			autoplaySpeed: 5000,
			lazyLoad: "progressive",
			slidesToShow: 3,
			slidesToScroll: 1,
			responsive: [
				{
					breakpoint: 767,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
					},
				}
			],
		};

		const slideCount = $this.children("li").length;
		const randomStart = Math.floor(Math.random() * slideCount);

		if (data["center"] === true) {
			$.extend(defaultOptions, {
				centerMode: true,
				centerPadding: "30px",
				variableWidth: true
			});
		} else if (data["fade"] === true) {
			$.extend(defaultOptions, {
				fade: true,
				pauseOnFocus: false,
				pauseOnHover: false
			});
			$this.on({
				beforeChange: function (event, slick, currentSlide, nextSlide) {
					$(".slick-slide", this).eq(currentSlide).addClass("preve-slide");
					$(".slick-slide", this).eq(nextSlide).addClass("fadeAnimetion");
				},
				afterChange: function () {
					$(".preve-slide", this).removeClass("preve-slide fadeAnimetion");
				}
			});
			$this.find(".slick-slide").eq(0).addClass("fadeAnimetion");
		} else {
			$.extend(defaultOptions, {
				initialSlide: randomStart
			});
		}

		$this.slick(defaultOptions);
	});

	const $contentSliders = $(".contentsSlider").not("#recently-viewed-list");
	// #recently-viewed-list は動的に slide が生成され、実行タイミングが遅いので別途実行する
	const $recentlyViewedContentSliders = $("#recently-viewed-list.contentsSlider");
	const $AllContentSliders = $(".contentsSlider");

	function setContentSlider($silderElements) {
		const windowWidth = $(window).width();
		if ($silderElements.length) {
			$silderElements.each(function () {
				const $this = $(this);
				const pcshow = $this.data("pcshow") || 4;
				const pcscroll = $this.data("pcscroll") || 4;
				const spshow = $this.data("spshow") || 2;
				const spscroll = $this.data("spscroll") || 2;
				const infinite = !($this.data("infinite") == false || $this.hasClass("itemList--ranking"));

				const responsiveOptions = $this.data("spUnslick") ? [
					{
						breakpoint: 991,
						settings: "unslick"
					},
				] : [
					{
						breakpoint: 991,
						settings: {
							slidesToShow: 3,
							slidesToScroll: 3,
						},
					},
					{
						breakpoint: 768,
						settings: {
							slidesToShow: spshow,
							slidesToScroll: spscroll,
						},
					},
				];

				const defaultOptions = {
					dots: false,
					arrow: true,//20251009 尾 左右矢印消し
					infinite: infinite,
					lazyLoad: "progressive",
					slidesToShow: pcshow,
					slidesToScroll: pcscroll,
					autoplay: false,//20251009 尾 自動再生なし
					autoplaySpeed: 5000,
					speed: 450,
					swipe: true,
					responsive: [...responsiveOptions],
				};

				//251031下記コンソールエラー回避アクティブではないスライダーにフォーカスが当たっていた場合は解除(blur)
				$this.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
					var $focusedElement = $(document.activeElement);
					if ($focusedElement.length && $this.is($focusedElement.closest('.contentsSlider'))) {
						$focusedElement.blur();
					}
				});

				const breakpoint = 991;
				if (windowWidth >= breakpoint) {
					if (!$this.hasClass('slick-initialized')) {
						$this.slick(defaultOptions);
					}
				} else {
					if( ($this.data("spUnslick") == true)){
						if ($this.hasClass('slick-initialized')) {
							$this.slick('unslick');
						}
					}else {
						if (!$this.hasClass('slick-initialized')) {
							$this.slick(defaultOptions);
						}
					}
				}
			});
		}
	}
	setContentSlider($contentSliders);

	// #recently-viewed-list は動的に slide が生成され、実行タイミングが遅いので別途実行する
	// $recentlyViewedContentSliders に子要素が追加されたら setContentSlider を実行する
	if ($recentlyViewedContentSliders && $recentlyViewedContentSliders.length > 0) {
		// MutationObserverで子要素追加を監視
		$recentlyViewedContentSliders.each(function(){
			const targetNode = this;
			const observer = new MutationObserver(function(mutationsList) {
				for (const mutation of mutationsList) {
					if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
						setContentSlider($(targetNode));
						break;
					}
				}
			});
			observer.observe(targetNode, { childList: true, subtree: false });
		});
	}

	let contentSliderResizeTimer;
	$(window).on('resize', function() {
		clearTimeout(contentSliderResizeTimer);

		contentSliderResizeTimer = setTimeout(function() {
			setContentSlider($AllContentSliders);
		}, 300);
	});
// });
// ./251113 パフォーマンス改善：スライダー実行位置移動後

$(function() {
  const $fixedCartButton = $('#fixedCartButton');
  //let isVisible = false;

	if($fixedCartButton.length){
		$(window).on('scroll', function() {
			if($(this).scrollTop() > 800) {
				$fixedCartButton.fadeIn();
			}else {
				$fixedCartButton.fadeOut();
			}
		})
	}
});



// COORDINATEセクション
// 「もっと見る」ボタン下に背景テキスト移動(SP)
const sections = document.querySelectorAll('.shopify-section');

sections.forEach(section => {
	if (!section) return;
	const targetButton = section.querySelector("div div");
	if (!targetButton) return;
	if (targetButton.className.includes('custom_liquid_button_coordinate-padding')) {
		targetButton.classList.add('coordinate-bg-text-move');
	}
});

// 20251112 尾 アコーディオン開閉用
$(function() {
    
    // 【既存のFAQ用JS】
    // アコーディオンの質問部分（開閉トリガー）のクリックイベントを、
    // documentの他のイベントハンドラよりも優先的に捕捉・処理する
    if($(window).width() < 768){
        $('.accordion-open').on('click', function(e) {
            e.stopPropagation();
            var $input = $(this).prev('.accordion-hidden');
            $input.click(); // チェックボックスを明示的にクリック
            return true; 
        });
    }

    // --- ここからスペックアコーディオン用に追加 ---

    // 【スペックアコーディオン用JS】
    // .accordion-open-spec 要素上で発生したクリックイベントを捕捉
    if($(window).width() < 768){
        $('.accordion-open-spec').on('click', function(e) {
            // 1. **伝播の停止**: イベントが親要素（document）へ伝わるのを完全に停止
            //    他の `$(document).on("click", ...)` のコード群にイベントが渡るのを防ぎます。
            e.stopPropagation();
            
            // 隠しチェックボックスを特定 (隣接する直前の要素)
            var $input = $(this).prev('.accordion-hidden-spec');
            
            // 隠しチェックボックスを明示的にクリックし、開閉をトリガー
            $input.click();

            // 2. デフォルト動作（チェックボックスの切り替え）は許可し、
            // 他のイベントハンドラを無効化
            return true; 
        });
    }
});

